<template>
  <div>
     <div class="unishop-item-photo">
        <div class="unishop-item-thumbs unishop-thumbs-multiple ">
          <div class="slideshow-container" v-if="product.fotos.length > 0">
            <div v-for="(foto, index) in product.fotos" :key="index" class="fade in" ref="foto">
              <img oncontextmenu="return false" :src="(foto.url) ? foto.url : 'data:image/png;base64,' + foto.imagenBytes" @touchstart="handleTouchStart" @dragstart="handleDragStart" @dragend="handleDragEnd" :id="product.id" :idfoto="foto.id" draggable="true" >
            </div>
            <div class="product-button">
              <v-btn icon flat class="grey--text" @click="plusSlides(-1)"><v-icon>chevron_left</v-icon></v-btn>
              <v-btn icon flat class="grey--text" @click="plusSlides(1)"><v-icon>chevron_right</v-icon></v-btn>
            </div> 
          </div>
          <img v-else src='@/assets/images/noimg.jpg' :alt="product.descripcion">  
        </div>
      </div>
      <div class="unishop-item-name w-100">
          <h2 class="primary-color h5 text-uppercase mb-0 font-weight-medium">{{ product.modelo }}</h2>
          <p class="d-flex mb-0">{{ product.color }}<span class="no-flex my-0 h5 ml-auto floar-right font-weight-black"> {{ precio }} €</span></p>
        </div>
  </div>
</template>
<script>
import { TiendaApiService } from '@/api/TiendaApiService'
const tiendaApiService = new TiendaApiService()

export default {
  name: 'products',
  props: ['product'],
  data () {
    return {
      selected: 1,
      fotoDefecto: '',
      fotoSecundaria: '',
      precio: '',
      slideIndex: 1
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init() {
      this.getPrecio()
      this.showSlides(this.slideIndex)
    },
    getPrecio() {
      outer_loop:
      for (var i = 0; i < this.product.tallas.length; i++) {
        for (var y = 0; y < this.product.tallas[i].stocks.length; y++) {
          if (this.product.tallas[i].stocks[y].precio) {
            this.precio=this.product.tallas[i].stocks[y].precio.precio
            if (this.product.tallas[i].stocks[y].id.id_op == this.opId) {
              break outer_loop
            } 
          }
        }
      }
    },
    handleTouchStart(e) {
      this.$root.$emit('addToCanvas', e.currentTarget)
    },
    handleDragStart(e) {
      var images = document.querySelectorAll('.productos-look img');
      [].forEach.call(images, function (img) {
          img.classList.remove('img_dragging');
      });
      e.currentTarget.classList.add('img_dragging');
    },
    handleDragEnd(e) {
    // this/e.target is the source node.
      var images = document.querySelectorAll('.productos-look img');
      [].forEach.call(images, function (img) {
          img.classList.remove('img_dragging');
      });
    },
    plusSlides(n) {
      this.showSlides(this.slideIndex += n);
    },
    currentSlide(n) {
      this.showSlides(this.slideIndex = n);
    },
    showSlides(n) {
      var i;
      if (this.product.fotos && this.$refs.foto) {
        if (n > this.product.fotos.length) {this.slideIndex = 1}    
        if (n < 1) {this.slideIndex = this.product.fotos.length}
        for (i = 0; i < this.product.fotos.length; i++) {
            this.$refs.foto[i].hidden = true;  
        }
        this.$refs.foto[this.slideIndex-1].hidden = false;  
      }
    }
  }
}
</script>



